import React from "react";
import {Col, Container, Image, Row} from "react-bootstrap";
import continousMonitoring from './../../assets/img/continous-monitoring.webp';
import proActiveNotifications from './../../assets/img/proactive-notifications.webp';
import visualAnalysis from './../../assets/img/visual-analysis.webp';
import {useTranslation} from "react-i18next";

const RealtimeMonitoring = () => {
    const {t} = useTranslation();
    return (
        <Container className="my-5">
            <h1 className="text-center mb-4">{t('pages.realtimeMonitoring.title')}</h1>
            <p className="text-center mb-5">{t('pages.realtimeMonitoring.description')}</p>

            {/* Section 1 */}
            <Row className="align-items-center mb-5">
                <Col md={6}>
                    <h2>{t("pages.realtimeMonitoring.sections.1.title")}</h2>
                    <p>
                        {t("pages.realtimeMonitoring.sections.1.descriptions.1")}
                    </p>
                    <p>
                        {t("pages.realtimeMonitoring.sections.1.descriptions.2")}
                    </p>
                </Col>
                <Col md={6}>
                    <Image
                        src={continousMonitoring}
                        alt={t("pages.realtimeMonitoring.sections.1.image.alt")}
                        fluid
                        className={"img-fluid rounded"}
                    />
                </Col>
            </Row>

            {/* Section 2 */}
            <Row className="align-items-center mb-5">
                <Col md={6}>
                    <Image
                        src={proActiveNotifications}
                        alt={t("pages.realtimeMonitoring.sections.2.image.alt")}
                        fluid
                        className={"img-fluid rounded"}
                    />
                </Col>
                <Col md={6}>
                    <h2>{t("pages.realtimeMonitoring.sections.2.title")}</h2>
                    <p>
                        {t("pages.realtimeMonitoring.sections.2.descriptions.1")}
                    </p>
                    <p>
                        {t("pages.realtimeMonitoring.sections.2.descriptions.2")}                    </p>
                </Col>
            </Row>

            {/* Section 3 */}
            <Row className="align-items-center">
                <Col md={6}>
                    <h2>{t("pages.realtimeMonitoring.sections.3.title")}</h2>
                    <p>
                        {t("pages.realtimeMonitoring.sections.3.descriptions.1")}
                    </p>
                    <p>
                        {t("pages.realtimeMonitoring.sections.3.descriptions.2")}                    </p>
                </Col>
                <Col md={6}>
                    <Image
                        src={visualAnalysis}
                        alt={t("pages.realtimeMonitoring.sections.3.image.alt")}
                        fluid
                        className={"img-fluid rounded"}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default RealtimeMonitoring;
